// extracted by mini-css-extract-plugin
export default {"Signup":"Signup_Signup__ak8E8","close":"Signup_close__9zaXC"};